import type { VehicleId } from '../../types/gcs/vehicle';
import type { GcsData } from '../../types/gcs/gcsData';
import { selectVehicleStatusCategory } from './selectVehicleStatusCategory';
import { VehicleStatusCategory } from '../../types/ui/vehicleStatusCategory';

/**
 * Selector to determine if a vehicle is under the current user's control
 * A vehicle is under user's control if:
 * - RPIC is in control for the vehicle's current mission, OR
 * - The vehicle status category is READY_FOR_TAKEOFF
 *
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns true if the vehicle is under the user's control
 */
export function selectIsVehicleUnderMyControl(
  data: Map<string, GcsData>,
  gcsId: string,
  vehicleId: VehicleId
): boolean {
  const gcsData = data.get(gcsId);
  if (!gcsData) return false;

  // Get the current mission for this vehicle
  const mission = gcsData.liveMissionsMap.get(vehicleId);
  if (!mission) return false;

  const statusCategory = selectVehicleStatusCategory(data, gcsId, vehicleId);

  // Check if RPIC is in control for this mission
  const rpicInControl = gcsData.missionRpicInControlMap.get(mission.missionId);
  if (
    (statusCategory === VehicleStatusCategory.INFLIGHT_NOMINAL ||
      statusCategory === VehicleStatusCategory.INFLIGHT_FAILURE_MODE) &&
    rpicInControl?.isMissionRpic
  ) {
    return true;
  }

  return statusCategory === VehicleStatusCategory.PREFLIGHT;
}
